import React, { useState, useEffect } from "react";
import api from "../../services/api";
import Button from "@material-ui/core/Button";

const packageVersion = require("../../../package.json").version;

const VersionControl = () => {
  const [storedVersion] = useState(window.localStorage.getItem("version") || "0.0.0");
  const [isMobile, setIsMobile] = useState(false);
  const [isHovered, setIsHovered] = useState(false); // Estado para efeito de hover

  useEffect(() => {
    // Detect the window size and set the isMobile state accordingly
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add event listener to update on resize
    window.addEventListener("resize", checkMobile);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleUpdateVersion = async () => {
    window.localStorage.setItem("version", packageVersion);

    // Save the current version to the database
    await api.post("/version", {
      version: packageVersion,
    });

    // Clear browser cache
    caches.keys().then((names) => {
      for (let name of names) caches.delete(name);
    });

    // Delay to ensure cache is cleared
    setTimeout(() => {
      window.location.reload(true); // Reload the page
    }, 1000);
  };

  const buttonStyle = {
    backgroundColor: isHovered ? "darkred" : "red", // Change background color on hover
    color: "white",
    fontWeight: "bold",
    position: isMobile ? "fixed" : "relative", // Fixed for mobile, relative for desktop
    right: isMobile ? "0" : "15px",
    left: isMobile ? "0" : "auto",
    bottom: isMobile ? "10px" : "auto",
    top: isMobile ? "auto" : "auto",
    width: isMobile ? "100%" : "auto", // Adjust width for mobile
    fontSize: isMobile ? "10px" : "12px", // Adjust font size for mobile
    padding: isMobile ? "10px 0" : "4px 8px", // Adjust padding for mobile
    textAlign: "center", // Center text
    display: "block", // Ensure button takes full width
    cursor: "pointer", // Show pointer cursor on hover
    transition: "background-color 0.3s ease", // Smooth transition for hover effect
    animation: "shake 1s infinite", // Apply the shaking animation
  };

  return (
    <div>
      {storedVersion !== packageVersion && (
        <Button
          variant="contained"
          size="small"
          style={buttonStyle}
          onMouseEnter={() => setIsHovered(true)} // Set hover effect on mouse enter
          onMouseLeave={() => setIsHovered(false)} // Remove hover effect on mouse leave
          onClick={handleUpdateVersion}
        >
          Nova versão disponível! Clique aqui para atualizar
        </Button>
      )}
      {/* Define the keyframes animation for the shake effect */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0); }
          }
        `}
      </style>
    </div>
  );
};

export default VersionControl;
